/* eslint no-use-before-define: ["error", { "variables": false }] */
import PropTypes from 'prop-types';
import React from 'react';
import { Linking, StyleSheet, View } from 'react-native-web';
import ParsedText from './ParsedText';
import Color from './Color';

const WWW_URL_PATTERN = /^www\./i;

export default class MessageText extends React.Component {
  constructor(props) {
    super(props);
    this.onUrlPress = this.onUrlPress.bind(this);
    this.onPhonePress = this.onPhonePress.bind(this);
    this.onEmailPress = this.onEmailPress.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.currentMessage.text !== nextProps.currentMessage.text ||
      this.props.playingAudioId !== nextProps.playingAudioId
    );
  }

  onUrlPress(url) {
    // When someone sends a message that includes a website address beginning with "www." (omitting the scheme),
    // react-native-web-parsed-text recognizes it as a valid url, but Linking fails to open due to the missing scheme.
    if (this.props.onUrlPress) {
      this.props.onUrlPress(url);
      return;
    }
    if (WWW_URL_PATTERN.test(url)) {
      this.onUrlPress(`http://${url}`);
    } else {
      Linking.canOpenURL(url).then((supported) => {
        if (supported) {
          Linking.openURL(url);
        }
      });
    }
  }

  //eslint-disable-next-line
  onPhonePress(phone) {
    /* GT -- the context doesn't work
    const options = ['Call', 'Text', 'Cancel'];
    const cancelButtonIndex = options.length - 1;

    this.context.actionSheet().showActionSheetWithOptions(
      {
        options,
        cancelButtonIndex
      },
      //eslint-disable-next-line
      (buttonIndex) => {
        // switch (buttonIndex) {
        //   case 0:
        //     Communications.phonecall(phone, true);
        //     break;
        //   case 1:
        //     Communications.text(phone);
        //     break;
        // }
      }
    );
    */
  }

  //eslint-disable-next-line
  onEmailPress(email) {
    // Communications.email(email, null, null, null, null);
  }

  render() {
    const linkStyle = StyleSheet.flatten([styles[this.props.position].link, this.props.linkStyle[this.props.position]]);
    const isAudioMessage = !!this.props.currentMessage.audio;

    // 如果是音频消息，使用按钮样式，不显示下划线
    const audioLinkStyle = isAudioMessage
      ? {
          ...linkStyle,
          textDecorationLine: 'none',
          cursor: 'pointer',
          userSelect: 'none'
        }
      : linkStyle;

    return (
      <View
        style={[
          this.props.currentMessage.textStyle,
          styles[this.props.position].container,
          this.props.containerStyle[this.props.position],
          isAudioMessage && {
            cursor: 'pointer',
            userSelect: 'none'
          }
        ]}
      >
        <ParsedText
          style={[
            styles[this.props.position].text,
            this.props.textStyle[this.props.position],
            this.props.customTextStyle,
            isAudioMessage && {
              cursor: 'pointer',
              userSelect: 'none'
            }
          ]}
          parse={[
            ...this.props.parsePatterns(audioLinkStyle),
            { type: 'url', style: audioLinkStyle, onPress: this.onUrlPress },
            { type: 'phone', style: audioLinkStyle, onPress: this.onPhonePress }
            //remove email parsing
            //,
            //{ type: 'email', style: linkStyle, onPress: this.onEmailPress }
          ]}
          currentMessage={this.props.currentMessage}
          playingAudioId={this.props.playingAudioId}
          position={this.props.position}
          childrenProps={{ ...this.props.textProps }}
        >
          {this.props.currentMessage.text}
        </ParsedText>
      </View>
    );
  }
}

const textStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginTop: 0, // Set to 0 - spacing from date separator is handled by Day component's marginBottom (30px)
  marginBottom: 0, // Reduced from 2 to 0, spacing handled by bottom container marginTop
  marginLeft: 15,
  marginRight: 15
};

const styles = {
  left: StyleSheet.create({
    container: {},
    text: {
      color: Color.text,
      ...textStyle
    },
    link: {
      color: Color.text,
      textDecorationLine: 'underline'
    }
  }),
  right: StyleSheet.create({
    container: {},
    text: {
      color: Color.text,
      ...textStyle
    },
    link: {
      color: Color.text,
      textDecorationLine: 'underline'
    }
  })
};

// Removed contextTypes - not used (actionSheet is commented out)
// MessageText.contextTypes = {
//   actionSheet: PropTypes.func
// };

MessageText.defaultProps = {
  position: 'left',
  currentMessage: {
    text: ''
  },
  containerStyle: {},
  textStyle: {},
  linkStyle: {},
  customTextStyle: {},
  textProps: {},
  parsePatterns: () => []
};

MessageText.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  currentMessage: PropTypes.object,
  onUrlPress: PropTypes.func,
  /*
  containerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style,
  }),
  */
  /*
  textStyle: PropTypes.shape({
    left: Text.propTypes.style,
    right: Text.propTypes.style,
  }),
  linkStyle: PropTypes.shape({
    left: Text.propTypes.style,
    right: Text.propTypes.style,
  }),
  */
  parsePatterns: PropTypes.func,
  textProps: PropTypes.object
  //customTextStyle: Text.propTypes.style,
};
